(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-cen10-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-cen10-countdown')) {
    class PVCen10Countdown extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        this.label = this.querySelector('[data-cen10-label]');
        this.clock = this.querySelector('[data-cen10-time]');
        this.londonDate = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        if (!Number.isFinite(this.deadline) || !this.label || !this.clock) return;
        this.update();
        if (Date.now() < this.deadline) {
          this.interval = window.setInterval(() => this.update(), 1000);
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const now = Date.now();
        const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        const notice = this.closest('.product-price__promo-notice[data-promo-code="CEN10"]');
        if (!remaining) {
          window.clearInterval(this.interval);
          if (notice) {
            notice.hidden = true;
            notice.style.display = 'none';
          } else {
            this.hidden = true;
          }
          return;
        }
        const label = this.londonDate.format(now) === this.londonDate.format(this.deadline - 1)
          ? this.dataset.labelToday
          : this.dataset.labelLater;
        if (this.label.firstChild.data !== label) this.label.firstChild.data = label;
        const pad = value => String(value).padStart(2, '0');
        const hours = pad(Math.floor(remaining / 3600));
        const minutes = pad(Math.floor(remaining % 3600 / 60));
        const seconds = pad(remaining % 60);
        this.clock.firstChild.data = `${hours}:${minutes}:${seconds}`;
        this.hidden = false;
      }
    }
    customElements.define('pv-cen10-countdown', PVCen10Countdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-centenary-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-centenary-notice')) {
    const start = Date.parse('2026-09-06T23:00:00Z');
    const hideRetiredOffers = () => {
      if (Date.now() < start) return;
      document.querySelectorAll('[data-promo-code="CEN10"], [data-promo-code="BDAY10"]').forEach(notice => {
        if (notice.style.display !== 'none') { notice.hidden = true; notice.style.display = 'none'; }
      });
    };
    class PVCentenaryNotice extends HTMLElement {
      connectedCallback() { this.update = this.update.bind(this); this.update(); }
      disconnectedCallback() { clearTimeout(this.timer); }
      update() {
        const now = Date.now();
        const end = Date.parse(this.dataset.end);
        this.hidden = this.dataset.enabled !== 'true' || now < start || now >= end;
        const notice = this.closest('[data-promo-id="CEN100"]');
        if (notice) notice.hidden = this.hidden;
        hideRetiredOffers();
        clearTimeout(this.timer);
        if (now < end) this.timer = setTimeout(this.update, Math.min(30000, Math.max(1, (now < start ? start : end) - now)));
      }
    }
    customElements.define('pv-centenary-notice', PVCentenaryNotice);
    const boot = () => {
      hideRetiredOffers();
      const observer = new MutationObserver(hideRetiredOffers);
      observer.observe(document.body, {childList: true, subtree: true});
      if (Date.now() < start) setTimeout(hideRetiredOffers, Math.min(2147483647, start - Date.now()));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
    else boot();
  }
  } catch(e) { console.error(e); }
})();

})();
